// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"4ffddab7","162":"5763ab25","343":"d697f72e","809":"2b42416f","953":"944c82d1"}[chunkId] + ".chunk.css";
};